/**
 * A low-performance monad implementation.
 */
class Box<T> {
    value: T;

    constructor(value: T) {
        this.value = value;
    }

    map<U>(transformer: (v: T) => U): Box<U> {
        return new Box(transformer(this.value));
    }
}

export function monadify<T>(value: T): Box<T> {
    return new Box(value);
}

class OptionalBox<T> {
    value: T | undefined;

    constructor(value: T | undefined) {
        this.value = value;
    }

    map<U>(transformer: (v: T) => U): OptionalBox<U> {
        if (this.value !== undefined) {
            return new OptionalBox(transformer(this.value));
        }
        return OptionalBox.empty();
    }

    else(supplier: () => T): T {
        if (this.value !== undefined) {
            return this.value;
        }
        return supplier();
    }

    static empty<T>(): OptionalBox<T> {
        return new OptionalBox<T>(undefined);
    }
}

export function optional<T>(value: T | undefined): OptionalBox<T> {
    return new OptionalBox(value);
}
